import { useZustandLocation } from "@faire/retailer-visitor-shared/app/_lib/routing/useZustandLocation";
import { pathMatchesRoute } from "@faire/web--source/common/routes/RouteMatcher";
import { route as notificationsPage } from "@faire/web-api--source/routes/user/notifications";

export const useIsOnNotificationsPage = () => {
  const { pathname } = useZustandLocation((state) => state.pathname);
  return pathMatchesRoute(pathname, notificationsPage);
};
